<template>
  <ClientIncomingRegionReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import ReportService from "@/services/report.service"
import _ from "underscore"
import Moment from "moment";
import {AllowClientIncomingStatistics} from "@/enums/permission";
import ClientIncomingRegionReport from "@/components/report/ClientStatistics/ClientIncomingRegionReportComponent.vue";
import Mapper from "@/mappers";

export default {
  name: "ClientIncomingRegionReportView",
  components: {
    ClientIncomingRegionReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowClientIncomingStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, selectedRegions, selectedClients, isSelectAllRegions, isSelectAllClients, type} = filters;
      this.$store.dispatch(LAYOUT_LOADING_START)

      ReportService.getClientIncomingRegionReport({
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        date: date ? Moment(date, "YYYY-MM") : null,
        type: type,
        selectedRegions: selectedRegions,
        selectedClients: selectedClients,
        isSelectAllRegions: isSelectAllRegions,
        isSelectAllClients: isSelectAllClients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                Client: Mapper.mapClient(rvm.Client),
                Regions: _.map(rvm.Regions, data => {
                  return {
                    Region: data.Region,
                    Count: data.Count
                  };
                })
              };
            });
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics)
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика организаций по регионам")
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>